/* inject module path import */
import { postsPath as posts } from 'posts/utils/path';
import { adminPath as admin } from 'admin/utils/path';
import { tweetsPath as tweets } from 'tweets/utils/path';
import { archivePath as archive } from 'archive/utils/path';
import { notificationsPath as notifications } from 'notifications/utils/path';
import { reportsPath as reports } from 'reports/utils/path';
import { settingsPath as settings } from 'settings/utils/path';
import { dashboardPath as dashboard } from 'dashboard/utils/path';
import { organizationPath as organization } from 'organization/utils/path';
import { topicsPath as topics } from 'topics/utils/path';
import { newsPath as news } from 'news/utils/path';
import { videosPath as videos } from 'videos/utils/path';
import { usersPath as users } from 'users/utils/path';
import { setsPath as sets } from 'sets/utils/path';
import { hashtagsPath as hashtags } from 'hashtags/utils/path';
import { influencersPath as influencers } from 'influencers/utils/path';
import { entitiesPath as entities } from 'influencers/utils/path';
import { trendsPath as trends } from 'trends/utils/path';
import { authPath as auth } from 'auth/utils/path';
export const path = {
  /* inject module path */
  posts,
  admin,
  tweets,
  archive,
  notifications,
  reports,
  settings,
  dashboard,
  organization,
  topics,
  news,
  videos,
  users,
  sets,
  hashtags,
  influencers,
  entities,
  trends,
  auth,
  home: '/',
};
